module.exports = new __parcel__URL__("appdevelopment2.6b88d29a.png").toString();